/**
 * Initialize library filter actions
 */
export function initLibraryFilters() {
	if (document.body.dataset.libraryFiltersInitialized === "true") {
		return;
	}

	document.body.dataset.libraryFiltersInitialized = "true";

	document.addEventListener("click", async function (event) {
		const button = event.target.closest("[data-copy-current-url]");
		if (!button) {
			return;
		}

		event.preventDefault();

		const currentUrl = window.location.href;

		try {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(currentUrl);
				return;
			}

			const textarea = document.createElement("textarea");
			textarea.value = currentUrl;
			textarea.setAttribute("readonly", "");
			textarea.style.position = "absolute";
			textarea.style.left = "-9999px";
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
		} catch (error) {
			console.error("Failed to copy current URL", error);
		}
	});
}
